"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventbriteEventImportDto = void 0;
const swagger_1 = require("@nestjs/swagger");
/** An Eventbrite event mapped to the admin event form's fields. Nothing is saved until the admin saves the form. */
class EventbriteEventImportDto {}
exports.EventbriteEventImportDto = EventbriteEventImportDto;
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Eventbrite event ID.'
}), __metadata("design:type", String)], EventbriteEventImportDto.prototype, "eventbriteId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Public Eventbrite page of the event.'
}), __metadata("design:type", String)], EventbriteEventImportDto.prototype, "url", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], EventbriteEventImportDto.prototype, "name", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Plain-text description (summary + full description), ready for the Content field.'
}), __metadata("design:type", String)], EventbriteEventImportDto.prototype, "content", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Start, ISO 8601 UTC.'
}), __metadata("design:type", Object)], EventbriteEventImportDto.prototype, "eventStartDate", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'End, ISO 8601 UTC.'
}), __metadata("design:type", Object)], EventbriteEventImportDto.prototype, "eventEndDate", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'IANA time zone of the event, e.g. America/Chicago.'
}), __metadata("design:type", Object)], EventbriteEventImportDto.prototype, "timezone", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Eventbrite status: draft, live, started, ended, completed or canceled.'
}), __metadata("design:type", String)], EventbriteEventImportDto.prototype, "status", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], EventbriteEventImportDto.prototype, "isOnline", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Venue name on Eventbrite.'
}), __metadata("design:type", Object)], EventbriteEventImportDto.prototype, "venueName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'One-line venue address on Eventbrite.'
}), __metadata("design:type", Object)], EventbriteEventImportDto.prototype, "address", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], EventbriteEventImportDto.prototype, "isFree", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Cheapest ticket in minor units (cents), when Eventbrite reports it.'
}), __metadata("design:type", Object)], EventbriteEventImportDto.prototype, "minPriceCents", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Most expensive ticket in minor units (cents).'
}), __metadata("design:type", Object)], EventbriteEventImportDto.prototype, "maxPriceCents", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'ISO currency of the prices, e.g. USD.'
}), __metadata("design:type", Object)], EventbriteEventImportDto.prototype, "currency", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Original event image on Eventbrite.'
}), __metadata("design:type", Object)], EventbriteEventImportDto.prototype, "imageUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'The event image as a data: URL, so the admin can use it as the flyer without a cross-origin fetch. Null when it could not be downloaded.'
}), __metadata("design:type", Object)], EventbriteEventImportDto.prototype, "imageDataUrl", void 0);
//# sourceMappingURL=EventbriteEventImport.dto.js.map